import React, {Component} from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import Card from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import _ from "underscore";
import Slider from 'react-slick';

import LocatorFormHeader from "./LocatorFormHeader"
import LocatorResult from './LocatorResult';
import ResponsiveLayout from '../common/ResponsiveLayout';
import api from '../../api/api';
import attributeIds from "../../api/attributeIds";
import GoogleMap from './GoogleMap';
import Tracker from '../common/Tracker';
import ResultsBatcher from '../../api/ResultsBatcher';

import checkedIcon from "../../img/ic-check-on.svg";
import uncheckedIcon from "../../img/ic-check-off.svg";
import filterIcon from '../../img/ic-filter.svg';
import spinnerIcon from '../../img/ic-spinner.svg';

import '../../css/LocatorFormMobile.css';
import "../../css/font-awesome.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const DEFAULT_COORDS = [30.267269, -97.743147];

const CATEGORY = "locator";

const checkBoxFilters = [
    {
        label: "Open Weekends",
        key: "openWeekends",
        apply: (location) => {
            return location.businessHours && (location.businessHours.saturdayOpen || location.businessHours.sundayOpen);
        }
    }, {
        key: "hideHospitalBased",
        label: "Hide hospital based locations",
        apply: (location) => {
             return location.attributes[attributeIds.facilityType] != null && !_.contains(location.attributes[attributeIds.facilityType].choice, attributeIds.hospitalBased)
         }
    }, {
        key: "acceptsMedicare",
        label: "Accepts Medicare",
        apply: (location) => {
            return location.attributes[attributeIds.acceptedHealthCarePlans] != null && _.contains(location.attributes[attributeIds.acceptedHealthCarePlans].choice, attributeIds.acceptsMedicare);
        },
    }, {
        key: "acceptsOutsidePatients",
        label: "Accepts patients from outside doctors",
        apply: (location) => {
            return location.attributes[attributeIds.acceptsOutsidePatients] != null && _.contains(location.attributes[attributeIds.acceptsOutsidePatients].choice, attributeIds.acceptsOutsidePatientsYes);
        }
    }, {
        key: "acceptsMedicaid",
        label: "Accepts Medicaid",
        apply: (location) => {
            return location.attributes[attributeIds.acceptedHealthCarePlans] != null && _.contains(location.attributes[attributeIds.acceptedHealthCarePlans].choice, attributeIds.acceptsMedicaid);
        },
    },
];

class LocatorFormDesktopLayout extends Component {
    render() {
        return (
            <div style={{flex: 1, display: "flex", flexDirection: "column", overflow: "hidden"}}>
                <div>
                    <LocatorFormHeader
                        searchRadius={this.props.searchRadius}
                        onSearchUpdate={this.props.searchUpdate}
                        onSearchRadiusUpdate={this.props.onSearchRadiusUpdate}
                        updateGeoQuery={this.props.updateGeoQuery} />
                </div>
                <div className="locator-form-content-container">
                    <div className="formContentInner horizontal" >
                        <LocatorFilterWidget filter={this.props.filter} onFilterUpdate={this.props.onFilterUpdate}/>
                        <hr className="locatorFormDivider"/>
                        <div style={{paddingTop: "10px"}}>
                            <SelectField
                                multiple={true}
                                fullWidth={true}
                                underlineStyle={{display: "none"}}
                                value={this.props.filter.medicationsAvailable}
                                onChange={this.props.onMedicationChange}
                                selectionRenderer={this.props.medicationSelectionRenderer}>
                                {this.props.getMedicationsAvailableOptions()}
                              </SelectField>
                        </div>
                        <hr className="locatorFormDivider"/>
                        <div style={{paddingTop: "10px"}}>
                            <SelectField
                                multiple={true}
                                fullWidth={true}
                                underlineStyle={{display: "none"}}
                                value={this.props.filter.specialty}
                                onChange={this.props.onSpecialtyChange}
                                selectionRenderer={this.props.specialtySelectionRenderer}>
                                {this.props.getSpecialtyOptions()}
                            </SelectField>
                        </div>
                    </div>
                    <hr className="bigDivider"/>
                    {this.props.loading ?
                        <div style={{display: "flex", alignItems: "center", marginTop: "50px", flexDirection: "column"}}>
                            <div>
                                <CircularProgress size={50} />
                            </div>
                            <div className="locator-finding-location">
                                Finding Current Location...
                            </div>
                        </div>
                        :
                        <div className="locatorResults" onMouseOut={this.props.onResultsMouseOut}>
                            {this.props.filteredResults.length ?
                                this.props.filteredResults.map((result, index) => {
                                    return (
                                        <div key={"locator-result-" + index}>
                                            <LocatorResult
                                                result={result}
                                                onMouseOver={this.props.onMouseOver.bind(null, index)}
                                                onClick={this.props.onLocationSelect.bind(null, result)}
                                                imageSize={118} />
                                        </div>
                                    )
                                })
                                :
                                <div className="locator-results-empty">
                                    <div className="locator-results-empty-title">
                                        No results to display.
                                    </div>
                                    <div className="locator-results-empty-subtitle">
                                        Try to broaden your search.
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>

            </div>
        )
    }
}

class LocatorFormMobileLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: "",
            showFilters: false,
            distanceOptions: this.getDistanceOptions(),
            hasTouchedSlider: false,
            errors: {}
        }
    }

    componentWillMount() {
        //KBM - TODO
        // this.interval = window.setInterval(() => {
        //     if (this.refs.slider) {
        //         this.refs.slider.slickNext();
        //     }
        // }, 5000);
    }

    componentWillUnmount() {
        window.clearInterval(this.interval);
    }

    toggleFilters = () => {
        this.setState((state) => {
            return {
                showFilters: !state.showFilters
            };
        })
    }

    getDistanceOptions = () => {
        var ret = [];
        for (var i = 1; i * 5 <= 100; i++) {
            ret.push(i * 5);
        }
        return ret;
    }

    onSliderTouch = () => {
        window.clearInterval(this.interval);
        this.interval = null;
    }

    render() {
        let sliderSettings = {
            dots: false,
            arrows: false,
            infinite: false,
            initialSlide: 0,
            speed: 500,
            swipe: true,
            afterChange: this.props.onMouseOver,
            centerMode: true,
            centerPadding: "30px",
            adaptiveHeight: false
        }

        return (
            <div className="locator-form-container-mobile">
                <LocatorFormHeader
                    searchRadius={this.props.searchRadius}
                    onSearchUpdate={this.props.searchUpdate}
                    onSearchRadiusUpdate={this.props.onSearchRadiusUpdate}
                    updateGeoQuery={this.props.updateGeoQuery} />
                <div className="locator-form-filter-summary-mobile" onClick={this.toggleFilters}>
                    <div>
                        <img src={filterIcon} style={{marginRight: "12px"}} alt="filter"/> Filters <img src={spinnerIcon} style={{float: "right", marginTop: "10px"}} alt="spinner" />
                    </div>
                </div>
                <div style={{position: "relative", display: "flex", flexDirection: "column", flex: 1}}>
                    <GoogleMap
                        results={this.props.filteredResults}
                        focusedIndex={this.props.focusedIndex || 0}
                        mobile={true}
                        imageSize={78} />
                </div>
                <div className="locator-form-results-mobile">
                    {this.props.loading ?
                        <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
                            <div>
                                <CircularProgress size={50} />
                            </div>
                            <div className="locator-finding-location">
                                Finding Current Location...
                            </div>
                        </div>
                        :
                        this.props.filteredResults.length ?
                            <div onTouchStart={this.onSliderTouch} onClick={this.onSliderTouch}>
                                <Slider {...sliderSettings} ref="slider" >
                                    {this.props.filteredResults.map((result, index) => {
                                        return (
                                            <div style={{height: "100%", position: "relative", flex: 1}} key={"locator-result-" + index}>
                                                <Card className="locator-form-result-card-mobile">
                                                    <LocatorResult
                                                        result={result}
                                                        imageSize={78}
                                                        onClick={this.props.onLocationSelect.bind(null, result)} />
                                                </Card>
                                            </div>
                                        )
                                    })}
                                </Slider>
                            </div>
                            :
                            <div className="locator-results-empty">
                                <div className="locator-results-empty-title">
                                    No results to display.
                                </div>
                                <div className="locator-results-empty-subtitle">
                                    Try to broaden your search.
                                </div>
                            </div>
                    }
                </div>
                <Dialog
                    open={this.state.showFilters}
                    contentStyle={{width: "90%"}}
                    autoScrollBodyContent={true}
                    actions={[
                        <FlatButton
                            labelStyle={{color: "#1c5c7f"}}
                            label="Done"
                            onClick={this.toggleFilters} />
                    ]}>
                    <div className="locator-form-filter-title">
                        filters
                    </div>
                    <div>
                        <SelectField
                            floatingLabelText="Search Radius"
                            fullWidth={true}
                            labelStyle={{fontFamily: "Lato", fontSize: "15px", color: "#175b80"}}
                            value={this.props.searchRadius}
                            onChange={this.props.onSearchRadiusUpdate}>
                            {this.state.distanceOptions.map((option) => {
                                return (<MenuItem primaryText={option + " miles"} value={option} key={option}/>)
                            })}
                        </SelectField>
                    </div>
                    <LocatorFilterWidget filter={this.props.filter} onFilterUpdate={this.props.onFilterUpdate}/>
                    <div style={{paddingTop: "20px"}}>
                        <SelectField
                            multiple={true}
                            fullWidth={true}
                            value={this.props.filter.medicationsAvailable}
                            onChange={this.props.onMedicationChange}
                            selectionRenderer={this.props.medicationSelectionRenderer}>
                            {this.props.getMedicationsAvailableOptions()}
                          </SelectField>
                    </div>
                    <div style={{paddingTop: "20px"}}>
                        <SelectField
                            multiple={true}
                            fullWidth={true}
                            underlineStyle={{display: "none"}}
                            value={this.props.filter.specialty}
                            onChange={this.props.onSpecialtyChange}
                            selectionRenderer={this.props.specialtySelectionRenderer}>
                            {this.props.getSpecialtyOptions()}
                        </SelectField>
                    </div>
                </Dialog>
            </div>
        )
    }
}

class LocatorFilterWidget extends Component {

    render() {
        return (
            <div className="locator-form-filter-widget-container">
                {checkBoxFilters.map((filter) => {
                    return (
                        <div key={filter.key} className="locator-form-filter-widget-item">
                            <Checkbox
                                style={{margin: "5px 0 5px 0"}}
                                checkedIcon={<img src={checkedIcon} alt="checked icon"/>}
                                uncheckedIcon={<img src={uncheckedIcon} style={{verticalAlign: "middle"}} alt="unchecked icon" />}
                                onCheck={this.props.onFilterUpdate.bind(null, filter.key)}
                                label={filter.label}
                                labelStyle={{fontFamily: "Lato", fontSize: "15px", color: "#979a9f", fontWeight: "200"}}
                                key={"option-" + filter.key}
                                checked={this.props.filter[filter.key]}/>
                        </div>
                    )
                })}
            </div>
        )

    }
}

class LocatorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            filteredResults: [],
            filter: {
                openWeekends: false,
                acceptsMedicare: false,
                acceptsMedicaid: false,
                hideHospitalBased: false,
                acceptsOutsidePatients: false,
                medicationsAvailable: [],
                specialty: []
            },
            showMedicationsAvailable: false,
            loading: true,
            searchCoords: null,
            searchRadius: 30,
            medicationsAvailable: null,
            specialties: null,
            geoQuery: null
        }
        this.resultsBatcher = new ResultsBatcher(api, this.onBatchUpdate);
    }

    componentDidMount() {
        this.getMedicationsAvailable();
        this.getSpecialties();

        navigator.geolocation.getCurrentPosition(result => {
            Tracker.trackEvent(CATEGORY, "current position succeeded", "", "");
            if (result.coords && result.coords.latitude && result.coords.longitude) {
                api.trackSearchQuery("initial", this.state.searchRadius, result.coords.latitude, result.coords.longitude, this.state.filter);
            }

            // console.log("got location :o", result);
            this.geoQuery = this.initGeoQuery(result.coords.latitude, result.coords.longitude, this.state.searchRadius);
            this.setState({ searchCoords:[result.coords.latitude, result.coords.longitude] });
        }, (err) => {
            Tracker.trackEvent(CATEGORY, "current position failed", "", "");
            console.warn(`ERROR(${err.code}): ${err.message}`);
            this.geoQuery = this.initGeoQuery(DEFAULT_COORDS[0], DEFAULT_COORDS[1], this.state.searchRadius);
            this.setState({ searchCoords:[DEFAULT_COORDS[0], DEFAULT_COORDS[1]] });
        }, {maximumAge: 75000, enableHighAccuracy: false, timeout: 30000});
    }

    getMedicationsAvailable() {
        api.getMedicationsAvailable((medications) => {
            let medicationOptions = [];
            Object.keys(medications.groups).forEach((groupKey) => {
                Object.keys(medications.groups[groupKey].options).forEach((optionKey) => {
                    medicationOptions.push({key: optionKey, groupKey: groupKey, option: medications.groups[groupKey].options[optionKey]});
                });
            });
            medicationOptions.sort((l1, l2) => {
                if (l1.option.name < l2.option.name) {
                    return -1;
                } else if (l1.option.name > l2.option.name) {
                    return 1;
                }
                return 0;
            });
            this.setState({medicationsAvailable: medicationOptions});
        });
    }

    getSpecialties() {
        api.getPracticeSpecialty((specialties) => {
            let specialtyOptions = [];
            Object.keys(specialties.options).forEach((optionKey) => {
                specialtyOptions.push({key: optionKey, option: specialties.options[optionKey]});
            });
            specialtyOptions.sort((l1, l2) => {
                if (l1.option.name < l2.option.name) {
                    return -1;
                } else if (l1.option.name > l2.option.name) {
                    return 1;
                }
                return 0;
            });
            this.setState({specialties: specialtyOptions});
        });
    }

    initGeoQuery(lat, lng, radius) {
        return api.newGeoQuery(lat, lng, this.convertToKM(radius), this.onGeoFireKeyEntered, this.onGeoFireKeyExited);
    }

    updateGeoQuery = (lat, lng, radius) => {
        api.updateGeoQuery(this.geoQuery, lat, lng, this.convertToKM(radius));
    }

    onGeoFireKeyEntered = (key, resultLocation, distance) => {
        // console.log("result entered: %s", key);
        this.resultsBatcher.postResult({ key: key, resultLocation: resultLocation, distance: distance });
        // api.locationByKey(key, (location) => {
        //     console.log("query location: %o", location);
        //     if (location) {
        //         console.log("found location");
        //         location.key = key;
        //         location.distance = distance;
        //         this.setState(prevState => {
        //             var results = prevState.results
        //             results.push(location);
        //
        //             let filteredResults = this.applyFilters(prevState.filter, results);
        //             this.sortResults(filteredResults);
        //
        //             return {loading: false, results: results, filteredResults: filteredResults};
        //         });
        //     }
        // });
    }

    onBatchUpdate = (results) => {
        // console.log('onBatchUpdate', results, this.state.filter);
        this.setState((prevState) => {
            results = results.concat(prevState.results);

            let filteredResults = this.applyFilters(prevState.filter, results);
            // console.log('filteredResults', filteredResults);

            this.sortResults(filteredResults);
            return { loading: false, results: results, filteredResults: filteredResults };
        })


    }

    sortResults = (results) => {
        results.sort((l1, l2) => {
            return ((l2.isPreferred || false) - (l1.isPreferred || false)) || (l1.distance - l2.distance);
        });
    }

    onGeoFireKeyExited = (key) => {
        // console.log("result exited: %s", key);
        api.locationByKey(key, (location) => {
            if (location) {
                // console.log("found location to delete");
                this.setState(prevState => {
                    var results = prevState.results;

                    let resultIndex = -1;
                    results.some((result, index) => {
                        if (result.key === key) {
                            resultIndex = index;
                            return true;
                        }
                        return false;
                    });
                    if (resultIndex > -1) {
                        // console.log("splicing index: %d", resultIndex);
                        results.splice(resultIndex, 1);
                    }

                    let filteredResults = this.applyFilters(prevState.filter, results);

                    filteredResults.sort((l1, l2) => {
                        return ((l2.isPreferred || false) - (l1.isPreferred || false)) || (l1.distance - l2.distance);
                    });

                    return {loading: false, results: results, filteredResults: filteredResults};
                });
            }
        });
    }

    onSearchRadiusUpdate = (event, index, newRadius) => {
        Tracker.trackEvent(CATEGORY, "search radius change", newRadius + "", "");

        if (this.geoQuery) {
            this.setState({
                searchRadius: newRadius
            });

            this.updateGeoQuery(null, null, newRadius);
            // this.searchByLocation(this.state.searchCoords[0], this.state.searchCoords[1], newRadius);
        }
    }

    searchUpdate = (newSearch) => {
        this.setState((prevState) => {
            var search = prevState.search;
            _.extend(search, newSearch);
            return {search: search}
        })

    }

    onFilterUpdate = (filterKey, event, isChecked) => {
        Tracker.trackEvent(CATEGORY, "filter change", filterKey, isChecked + "");

        this.setState(prevState => {
            let filter = prevState.filter;
            filter[filterKey] = isChecked;

            let filteredResults = this.applyFilters(prevState.filter, prevState.results);
            this.sortResults(filteredResults);

            return {filter: filter, filteredResults: filteredResults};
        });
    }

    convertToKM(radius) {
        if (radius) {
            return radius * 1.60934;
        }
    }

    applyFilters(filters, results){
        var ret = [];

        results.forEach((location) => {

            for (var filter of checkBoxFilters){
                if(!filters[filter.key]){
                    continue;
                }
                // bail as soon as the first filter says no
                if(!filter.apply(location)){
                    return;
                }
            }

            for (var medicationIndex of filters.medicationsAvailable) {
                let medication = this.state.medicationsAvailable[medicationIndex];
                if (!location.attributes[medication.groupKey] || !location.attributes[medication.groupKey].choice || !location.attributes[medication.groupKey].choice.includes(medication.key)) {
                    return;
                }
            }

            if (filters.specialty) {
                for (var specialtyIndex of filters.specialty) {
                    if (!location.attributes[attributeIds.practiceSpecialty] || !location.attributes[attributeIds.practiceSpecialty].choice.includes(this.state.specialties[specialtyIndex].key)) {
                        return;
                    }
                }
            }

            ret.push(location);

        });

        this.props.plotResults(ret);

        return ret;
    }

    getMedicationsAvailableOptions = () => {
        if (this.state.medicationsAvailable) {
            return this.state.medicationsAvailable.map((medication, index) => (
                <MenuItem
                    key={"medication-" + index}
                    insetChildren={true}
                    checked={this.state.filter.medicationsAvailable.includes(index)}
                    value={index}
                    primaryText={medication.option.name}
                />
            ));
        }
        return null;
    }

    getSpecialtyOptions = () => {
        if (this.state.specialties) {
            return this.state.specialties.map((specialty, index) => (
                <MenuItem
                    key={"specialty-" + index}
                    insetChildren={true}
                    checked={this.state.filter.specialty.includes(index)}
                    value={index}
                    primaryText={specialty.option.name}
                />
            ));
        }
        return null;
    }

    onMedicationChange = (event, index, values) => {
        if (this.state.filter.medicationsAvailable.length || (values && values.length)) {
            Tracker.trackEvent(CATEGORY, "medication filter change", values.join(", "), "");
        }

        this.setState((state) => {
            let filter = state.filter;
            filter.medicationsAvailable = values;
            let filteredResults = this.applyFilters(filter, state.results);
            this.sortResults(filteredResults);

            api.trackMedicationFilter(null, filter, state.medicationsAvailable);
            return {filter: filter, filteredResults: filteredResults};
        });
    }

    onSpecialtyChange = (event, index, values) => {
        if (this.state.filter.specialty.length || (values && values.length)) {
            Tracker.trackEvent(CATEGORY, "specialty filter change", values.join(", "), "");
        }

        this.setState((state) => {
            let filter = state.filter;
            filter.specialty = values;
            let filteredResults = this.applyFilters(filter, state.results);
            this.sortResults(filteredResults);

            api.trackSearchFilter(null, filter, state.specialties);
            return { filter: filter, filteredResults: filteredResults };
        });
    }

    medicationSelectionRenderer = (values) => {
        var medications = [];
        values.forEach((value) => {
            medications.push(this.state.medicationsAvailable[value].option.name);
        });

        return (
            <div>
                <div style={{fontSize: "15px", fontFamily: "Lato", color: "#979a9f", lineHeight: "normal", fontWeight: "200"}}>
                    Medications Available:
                </div>
                <div style={{marginTop: "5px", fontSize: "15px", fontFamily: "Lato", color: "#1c5c7f", lineHeight: "normal"}}>
                    { medications.length ? medications.join(", ") : "Any medication" }
                </div>
            </div>
        );
    }

    specialtySelectionRenderer = (values) => {
        var specialties = [];
        values.forEach((value) => {
            specialties.push(this.state.specialties[value].option.name);
        });
        return (
            <div>
                <div style={{fontSize: "15px", fontFamily: "Lato", color: "#979a9f", lineHeight: "normal", fontWeight: "200"}}>
                    Specialty:
                </div>
                <div style={{marginTop: "5px", fontSize: "15px", fontFamily: "Lato", color: "#1c5c7f", lineHeight: "normal"}}>
                    { specialties.length ? specialties.join(", ") : "Any specialty" }
                </div>
            </div>
        );
    }

    render() {
        return (
            <ResponsiveLayout
                desktopLayout={LocatorFormDesktopLayout}
                mobileLayout={LocatorFormMobileLayout}
                {...this.state}
                {...this.props}
                searchUpdate={this.searchUpdate}
                onSearchRadiusUpdate={this.onSearchRadiusUpdate}
                updateGeoQuery={this.updateGeoQuery}
                onFilterUpdate={this.onFilterUpdate}
                onMedicationChange={this.onMedicationChange}
                onSpecialtyChange={this.onSpecialtyChange}
                medicationSelectionRenderer={this.medicationSelectionRenderer}
                specialtySelectionRenderer={this.specialtySelectionRenderer}
                getMedicationsAvailableOptions={this.getMedicationsAvailableOptions}
                getSpecialtyOptions={this.getSpecialtyOptions}
                onResultsMouseOut={this.props.onResultsMouseOut}
            />
        )

    }
}

export default LocatorForm;



// WEBPACK FOOTER //
// ./src/components/locator/LocatorForm.js